// extracted by mini-css-extract-plugin
module.exports = {"facetMenuHighlightItemWrapper":"SubCategoryItem_facetMenuHighlightItemWrapper__ikUg_"};